import { Button } from '@src/common/components/button/Button';
import { Checkbox } from '@src/common/components/Checkbox';
import { LoadingSpinner } from '@src/common/components/LoadingSpinner';
import { PageLayout } from '@src/common/components/Page';
import { Stack } from '@src/common/components/Stack';
import { EventEmitter } from '@src/common/EventEmitter';
import { useMeasurement } from '@src/common/measurements/useMeasurement';
import type { ReactNode } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export type CollapsibleOrderSectionProps = {
  title: string;
  subtitle?: string;
  collapseEventName: string;
  uncollapseEventName: string;
  isLoading?: boolean;
  withMetricToggle?: boolean;
  children: ReactNode;
};

export const CollapsibleOrderSection = (
  props: CollapsibleOrderSectionProps,
) => {
  const { isMetric, setIsMetric } = useMeasurement();
  const { t } = useTranslation();
  const [isSectionCollapsed, setIsSectionCollapsed] = useState(false);

  const toggleCollapse = () => {
    if (isSectionCollapsed) {
      EventEmitter.emit(props.uncollapseEventName);
    } else {
      EventEmitter.emit(props.collapseEventName);
    }
    setIsSectionCollapsed((previous) => !previous);
  };

  return (
    <PageLayout title={props.title} subtitle={props.subtitle}>
      {props.isLoading && (
        <Stack alignItems="center" justifyContent="center" height="250px">
          <LoadingSpinner />
        </Stack>
      )}
      {!props.isLoading && (
        <>
          <Stack
            direction="row"
            justifyContent={props.withMetricToggle ? 'space-between' : 'end'}
          >
            {props.withMetricToggle && (
              <div>
                <Checkbox
                  label={t('isMetric')}
                  checked={isMetric}
                  onChange={(e) => setIsMetric(e.target.checked)}
                />
              </div>
            )}
            <Button onClick={toggleCollapse} aria-label="toggle-collapse">
              {isSectionCollapsed ? t('uncollapseAll') : t('collapseAll')}
            </Button>
          </Stack>
          {props.children}
        </>
      )}
    </PageLayout>
  );
};
